import Mail from "../assets/images/mail.png";
import blue from "../assets/images/blue.png";
import Logo from "../assets/images/Logo.png";
import playstore from "../assets/images/play store.png";
import appstore from "../assets/images/app store.png";
import { FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom"

export default function Footer() {
  return (
    <div>
      <div className="container -mt-[88px]">
        <div className=" flex max-sm:flex-col items-center justify-between gap-5 sm:gap-28 py-6 px-12 bg-gradient-to-r from-purple to-darkPurple text-center rounded-[10px]">
          <div >
            <p className="font-bold">Get in touch with us!</p>
          </div>
          <a
            className="flex gap-1 items-center bg-purple200 px-4 py-4 rounded-[20px]"
            href="https://x.com/KoyeHQ"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaXTwitter className="size-10 text-lightPurple"/>
            <p>@KoyeHQ</p>
            <img src={blue} alt="blue" />
          </a>
          <a className="flex gap-4 items-center" href="mailto:support@koye.ng">
            <img src={Mail} alt="mail" />
            <p className="text-[16px]">support@koye.ng</p>
          </a>
        </div>
        <div className="flex max-sm:flex-col mt-[60px] justify-between gap-10 sm:items-center ">
          <div>
            <img src={Logo} alt="logo" className="-ml-5"/>
            <ul className="space-y-4">
              <li>
                <a href="how">How to use Koye</a>
              </li>
              <li>
                <a href="approach">Our Approach</a>
              </li>
              <li>
                <a href="price">Pricing</a>
              </li>
              <li>
                <a href="contact">Contact Us</a>
              </li>
            </ul>
           <Link to="premium"> <button className="btn-purple btn mt-4">Get Premium</button></Link>
          </div>
          <div>
            <p className="sm:text-[36px] text-[24px] sm:text-right max-sm:mt-10 mb-10">Your personal lecturer, <br />
            on your phone.</p>
             <div className="flex gap-8 mb-12">
              <button>
                <img src={appstore} alt="apple" className="w-[200px]"/>
              </button>
              <button>
                <img src={playstore} alt="play"  className="w-[200px]" />
              </button>
            </div>
          </div>
         
        </div> 
       
      </div> 
      <span className="w-full block bg-lightPurple h-[0.5px] mt-[30px]"></span>

          <ul className="flex max-sm:flex-col container gap-2 pb-[30px] justify-between">
            <div className="flex max-sm:flex-col gap-2 sm:gap-10">
            <li><a href="/privacy">Privacy Policy</a></li>
            <li><a href="/terms">Terms of Use</a></li>
            <li><a href="/sales-and-refunds">Sales and Refunds</a></li>
            </div>
            <li><a href="https://xenta.ng" target="_blank" rel="noopener noreferrer">© 2025 All Rights Reserved. Xenta Ltd.</a></li>
          </ul>
    </div>
  );
}
